import { createAsyncThunk } from '@reduxjs/toolkit';
import { getInviteContent, GetInviteContentReq } from '@services/cgi';
import { MeetingItem } from '@tencent/wemeet-websdk-next';
import { checkIfCanJoinMeeting, handleNormalError } from '@utils/helper/meeting';
import { atou } from '@utils/string';

import wemeetClient from '@utils/wemeetClient';
import { setMeetingCheckResult, setMeetingInfo, setMeetingSettings } from './meeting.slice';

export const fetchInviteContent = createAsyncThunk('meeting/invite', async (params: GetInviteContentReq) => {
  const res = await getInviteContent(params);
  // @ts-ignore
  return atou(res?.invite_content ?? '');
});

export const fetchAndCheckMeetingInfo = createAsyncThunk<{ checkResult: boolean; meetingInfo?: MeetingItem }, string>(
  'meeting/info',
  async (meetingCode, { dispatch }) => {
    try {
      const meetingInfo: MeetingItem = await wemeetClient.meetingCtrl.queryMeetingInfoByCode(meetingCode);
      dispatch(setMeetingInfo(meetingInfo));
      dispatch(
        setMeetingSettings({
          media_settings_list: meetingInfo.media_settings_list,
        }),
      );
      const checkResult = checkIfCanJoinMeeting(meetingInfo);
      dispatch(setMeetingCheckResult(checkResult));
      return {
        checkResult,
        meetingInfo,
      };
    } catch (err: any) {
      handleNormalError(err?.message ?? '');
      return {
        checkResult: false,
      };
    }
  },
);
